import { RootState } from '@/store/types';
import { Dictionary } from '@shared/interfaces/dictionary';

export interface ErrorEndpoint {
    PublishError(Error: JavascriptError, state: RootState): Promise<void>;
}

export interface JavascriptError {
    location: string;
    errorMessage: string;
    stackTrace: string;
    customData?: Dictionary<string>;
}

export enum ErrorSource {
    CrossOrigin = 'cross_origin',
    ThirdParty = 'third_party',
    Network = 'network',
    Application = 'application',
    Expected = 'expected',
}

export enum ErrorSeverity {
    P0 = 'p0', // Critical
    P1 = 'p1', // High
    P2 = 'p2', // Medium
    P3 = 'p3', // Low
}

export enum ErrorCategory {
    Client = 'error_client',
    Server = 'error_server',
    Network = 'error_network',
    CartEmpty = 'error_cart_empty',
    ThirdParty = 'error_third_party',
    Amelia = 'error_amelia',
    Other = 'error_other',
}

export interface ErrorClassification {
    source: ErrorSource;
    severity: ErrorSeverity;
    errorCategory: ErrorCategory;
    shouldTrack: boolean;
    component?: string;
    // isRetryable: boolean;
    // shouldAlert: boolean;
    // shouldSendToSentry: boolean;
    // metadata?: Record<string, any>;
}
